
const tradeMarketsTypes = {
    setTradeMarketsList: 'SET_TRADE_MARKETS_LIST',
};

export default tradeMarketsTypes;